// routes
import { paths } from 'src/routes/paths';
// utils
import axios from 'src/utils/axios';

// ----------------------------------------------------------------------

export const STORAGE_KEY = 'salesRushAccessToken';

export const isValidToken = (token) => {
  const decoded = jwtDecode(token);
  const currentTime = Date.now() / 1000;
  return decoded.exp > currentTime;
};

const jwtDecode = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join('')
  );
  return JSON.parse(jsonPayload);
}

export const setSession = (token, key) => {
  if (token) {
    localStorage.setItem(key, token);
    axios.defaults.headers.common.Authorization = token;
    const { exp } = jwtDecode(token);
    tokenExpired(exp, key);
  } else {
    localStorage.removeItem(key);
    delete axios.defaults.headers.common.Authorization;
  }
};

const tokenExpired = (exp, key) => {
  const timeLeft = (exp * 1000) - Date.now();
  if (timeLeft <= 0) {
    localStorage.removeItem(key);
    window.location.href = paths.auth.login;
  }
};
